import React, { useEffect } from 'react';
import {
  SomaDrawer,
  SomaSubtitle,
  SomaIconButton,
  SomaParagraph,
} from '@soma/react';

import {
  useLocation,
} from 'react-router-dom';

import useNotification from 'store/Notification/queries/useNotification';
import useNotificationStore from 'store/Notification/state';

import Item from './Item';
import { groupByDate } from '../../../utils/helpers';
import { deleteCookie } from '../../../utils/cookies';
import * as s from './styles';

const Notification = () => {
  const { data: notifications } = useNotification();
  const { open, setOpen } = useNotificationStore();

  const location = useLocation();

  useEffect(() => {
    if (notifications?.length > 0 && notifications?.filter(item => !item.isReaded).length === 0) {
      deleteCookie('black/view-notification');
    }
  }, [notifications]);

  useEffect(() => {
    setOpen(false);
  }, [location]);

  return (
    <>
      <SomaDrawer
        open={open}
        placement="right"
        size="lg"
        onSomaDrawerOpen={() => setOpen(true)}
        onSomaDrawerClose={() => setOpen(false)}
      >
        <s.Container style={{ backgroundColor: '#F0F0F0', display: 'flex', flexDirection: 'column', padding: '15px' }}>
          <s.Header>
            <SomaSubtitle variant="subtitle-2">Notificações</SomaSubtitle>
            <SomaIconButton
              icon="close"
              variant="ghost"
              size="md"
              aria-label="Fechar notificações"
              onSomaClick={() => setOpen(false)}
            />
          </s.Header>
          <s.SliderContainer>
            {notifications?.length > 0 && Object.values(groupByDate(notifications || [])).map((value) => {
              if (value.items.length > 0) {
                return (
                  <>
                    <SomaParagraph variant="paragraph">{value.name}</SomaParagraph>
                    {value.items?.map(item => (
                      <Item item={item} handleOpen={setOpen} />
                    ))}
                  </>
                );
              }
              return <></>;
            })}
          </s.SliderContainer>
        </s.Container>
      </SomaDrawer>
    </>
  );
};
export default Notification;
